



































































import Vue from 'vue';
import store from '@/store';
import router from '@/router';
import { mapState, mapGetters } from 'vuex';
import Sticky from 'vue-sticky-directive';
import TeamCreate from '@/components/team/team-create.vue';
import TeamResults from '@/components/team/teams-results.vue';

export default Vue.extend({

  name: 'TeamsPage',

  directives: {
    Sticky
  },

  components: {
    'team-create': TeamCreate,
    'team-results': TeamResults,
  },

  props: {
    viewpointName: {
      type: String,
      default: 'Default Viewpoint',
    },
    factorGroupName: {
      type: String,
      default: 'Score',
    },
    status: {
      type: String,
      default: 'ok',
      required: false,
      validator: (value) => {
        return [
          'ok',
          'loading',
          'syncing',
          'synced',
          'version-conflict',
          'error'
        ].indexOf(value) !== -1
      }
    },
  },

  data() {
    return {
      updatedFlag: 0,
      showFavourites: false,
      searchQuery: '',
      dialog: false,
      drawer: false,
    };
  },

  created() {
    console.log('[ TeamsPage created() ]');
    if (!this.getIsLoggedIn) {
      router.push('/mls');
    }
  },

  mounted() {
  },

  watch: {
  },

  computed: {
    
     ...mapGetters([
      'getFavourites',
      'getIsLoggedIn',
      'getInstanceId',
      'getVpInstances',
      'getVpInstancesCount',
      'getVpInstanceList',
      'getVpInstanceListCount',
      'getVpGroups',
      'getVpGroupsCount',
      'getVpGroupsList',
      'getVpGroupsListCount',
      'getVpGroupInstances',
      'getVpGroupInstancesCount',
      'getVpGroupInstancesList',
      'getVpGroupInstancesListCount'
    ]),
   
    routeName(): any {
      return this.$route.name;
    },
    
    routeParam(): any {
      return this.$route.params.subSection;
    },
    
    isLoggedIn(): any {
      return this.$store.getters.getIsLoggedIn;
    },

    formatDate(): string {
      let newDate: Date = new Date
      let options: object = { year: 'numeric', month: 'long', day: 'numeric' };
      let locale: string = 'en-US';
      return newDate.toLocaleDateString(locale, options);
    },

  },

  methods: {

    newTeam() {
      store.dispatch('createTeam');
    },
    
    switchView(event: any) {
      this.showFavourites = event;
    },
    
    updateSearch(event: any) {
      console.log('[SEARCH UPDATED]: ' + event);
      this.searchQuery = event;
      this.updatedFlag++;
    },
    
    factorsUpdated() {
      this.updatedFlag++;
    },
    
    openFactors() {
      this.drawer = true;
    },

  },


});

